export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
          移动端阅读
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="w-32 h-32 md:w-40 md:h-40 flex-shrink-0 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20minimal%20smartphone%20showing%20a%20colorful%20manga%20reading%20app%20interface%20with%20Japanese%20comic%20style%20panels%2C%20warm%20orange%20accent%20colors%2C%20modern%20flat%20UI%20design%2C%20soft%20neutral%20background%2C%20digital%20illustration%20style%2C%20clean%20composition%2C%20professional%20app%20mockup&width=400&height=400&seq=app-qr-manga&orientation=squarish"
                alt="虫虫动漫移动端APP阅读界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                随时随地，畅享全集漫画
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                虫虫动漫移动端适配完美，无论是手机还是平板，下拉式阅读体验丝滑流畅。
                无需下载APP，浏览器打开即读，全集漫画完整版随时随地免费看。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-50 text-primary-700 rounded-full text-xs font-medium whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  手机适配
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-accent-50 text-accent-700 rounded-full text-xs font-medium whitespace-nowrap">
                  <i className="ri-tablet-line"></i>
                  平板优化
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-secondary-50 text-secondary-700 rounded-full text-xs font-medium whitespace-nowrap">
                  <i className="ri-speed-up-line"></i>
                  极速加载
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}